export interface ISize {
  height: number;
  width: number;
}
